import { createSelector } from "reselect";

export const configManagerLiteStepOneSelector = createSelector(
    state => state.configManagerLite.stepOne,
    state => state
);
